import { render } from "./AboutUs.vue?vue&type=template&id=cc6aa9d2&scoped=true"
import script from "./AboutUs.vue?vue&type=script&lang=ts"
export * from "./AboutUs.vue?vue&type=script&lang=ts"

import "./AboutUs.vue?vue&type=style&index=0&id=cc6aa9d2&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cc6aa9d2"

export default script